import { timeoutFetch } from 'utils/src/api/fetch'
import { publicRuntimeConfig } from '@/app/util/env'
import { appendParams } from '@/util/url'
import { GifResult, GifsResult } from '@giphy/js-fetch-api'

export const getUserFavorites = async (params: object, accessToken: string) => {
    const url = appendParams(new URL(`${publicRuntimeConfig.apiUrl}user/favorites`), params)
    const res = await timeoutFetch({
        url,
        options: {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                authorization: `Token ${accessToken}`,
                'Content-Type': 'application/json',
            },
        },
    })
    return (await res.json()) as GifsResult
}

export const addFavorite = async (gif_id: string, accessToken: string, cookie: string) => {
    return toggleFavorite(gif_id, accessToken, cookie, 'POST')
}

export const removeFavorite = async (gif_id: string, accessToken: string, cookie: string) => {
    return toggleFavorite(gif_id, accessToken, cookie, 'DELETE')
}

const toggleFavorite = async (gif_id: string, accessToken: string, cookie: string, method: 'POST' | 'DELETE') => {
    const f = await timeoutFetch({
        url: getUrl(`user/favorites`, accessToken),
        options: {
            method,
            body: `gif_id=${gif_id}`,
            headers: {
                cookie,
                Accept: 'application/json',
                Authorization: `Token ${accessToken}`,
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            },
        },
    })
    return (await f.json()) as GifResult
}

export const checkIsFavorite = async (gifId: string, accessToken: string) => {
    const result = await timeoutFetch({
        url: getUrl(`user/favorites/statuses`, accessToken),
        options: {
            method: 'POST',
            headers: {
                Authorization: `Token ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ gif_ids: [gifId] }),
        },
    })
    const r = await result.json()
    return r.data.length > 0
}

function getUrl(path: string, accessToken: string) {
    return appendParams(new URL(`${publicRuntimeConfig.apiUrl}${path}`), {
        api_key: publicRuntimeConfig.apiKey,
        access_token: accessToken,
    })
}
